import { Reciter } from '../class/reciter';
import { routes } from '../const/routes';

const collectionPageMarkupSchema = (reciter: Reciter) => {
  const SITE_URL = process.env.NEXT_PUBLIC_SITE_URL;
  return {
    '@type': 'CollectionPage',
    '@id': `${SITE_URL}${routes.reciters}/${reciter.slug}`,
    url: `${SITE_URL}${routes.reciters}/${reciter.slug}`,
    name: reciter.titleEn,
    isPartOf: {
      '@id': `${SITE_URL}/#website`,
    },
    description: reciter.biblioEn,
    inLanguage: 'en-US',
  };
};

export default collectionPageMarkupSchema;
